/**
 * @description Device type.
 */
export enum DeviceType {
	/**
	 * @description Mobile.
	 */
	mobile = 'mobile',

	/**
	 * @description Desktop.
	 */
	desktop = 'desktop',

	/**
	 * @description Table.
	 */
	tablet = 'tablet',
}

export type DeviceTypes = keyof typeof DeviceType;
/**
 * @description Get device.
 * @returns {DeviceType} Device.
 */
export function getDeviceType(): DeviceType.mobile | DeviceType.desktop {
	if (isMobile()) {
		return DeviceType.mobile;
	}
	return DeviceType.desktop;
}
function isMobile() {
	const isMobile = window.matchMedia;
	if (isMobile) {
		const match_mobile = isMobile('(pointer:coarse)');
		return match_mobile.matches;
	}
	return false;
}
export type DeviceTypeKeys = keyof typeof DeviceType;
